import React from 'react'
import { observer } from 'mobx-react'
import UserMarkerfile from './UserMarkerfile'
import { withTranslation } from 'react-i18next'

const UserMarkerfileList = ({ userMarkerfileList, markerfiles, onSelect, t }) => {
  const files = markerfiles || userMarkerfileList.markerfiles || []

  if (files.length === 0) {
    return (
      <div className='marker-file-pane__empty'>
        <span>{t('GLOBAL.NO_MARKERFILES', { defaultValue: 'No saved marker files' })}</span>
      </div>
    )
  }

  return (
    <ul className='marker-file-pane__list'>
      {files.map(markerfile => (
        <UserMarkerfile
          key={markerfile.id}
          markerfile={markerfile}
          userMarkerfileList={userMarkerfileList}
          onSelect={onSelect}
        />
      ))}
    </ul>
  )
}

export default withTranslation()(observer(UserMarkerfileList))
